import React from "react";
import "../styles/Books.css";

const Filters = ({
  searchQuery,
  setSearchQuery,
  category,
  setCategory,
  copyright,
  setCopyright,
  topic,
  setTopic,
  authorYearStart,
  setAuthorYearStart,
  authorYearEnd,
  setAuthorYearEnd,
  onSearch,
  errorMessage,
}) => {
  return (
    <section className="filters">
      <input
        type="text"
        placeholder="Search by title"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      <input
        type="text"
        placeholder="Search by topic"
        value={topic}
        onChange={(e) => setTopic(e.target.value.toLowerCase())}
      />
      <label for="id_select_language" hidden>
        Choose a Language:
      </label>
      <select
        id="id_select_language"
        value={category}
        onChange={(e) => setCategory(e.target.value)}
      >
        <option value="">Choose language...</option>
        <option value="en">English</option>
        <option value="es">Spanish</option>
        <option value="fr">French</option>
        <option value="it">Italian</option>
        <option value="fi">Finnish</option>
      </select>

      <label for="id_select_copyright" hidden>
        Choose Copyright:
      </label>
      <select
        id="id_select_copyright"
        value={copyright}
        onChange={(e) => setCopyright(e.target.value)}
      >
        <option value="">Choose copyright...</option>
        <option value="true">With</option>
        <option value="false">Without</option>
        <option value="true,false">Available information</option>
        <option value="null">Non available information</option>
      </select>

      <input
        type="number"
        placeholder="Author Year Start"
        value={authorYearStart}
        onChange={(e) => setAuthorYearStart(e.target.value)}
      />
      <input
        type="number"
        placeholder="Author Year End"
        value={authorYearEnd}
        onChange={(e) => setAuthorYearEnd(e.target.value)}
      />
      <button onClick={onSearch}>Search</button>
      {errorMessage && <p className="error-message">{errorMessage}</p>}
    </section>
  );
};

export default Filters;
